import {CONSULTANT_PHONE_DISPLAY, CONSULTANT_PHONE_HREF} from "@pg-rp/consultants";
import {HOMEMATCH_TINDER_BANNER_RECOMMENDATION_READY_CONTENT} from "@pg-rp/homematch-tinder";

export const HOME_MATCH_TINDER_BANNER_CONTENT = {
    // Shared with RP so the recommendations entry reads the same on both portals.
    RECOMMENDATION_READY: HOMEMATCH_TINDER_BANNER_RECOMMENDATION_READY_CONTENT,
    UNLOCK_REQUIRED: {
        TITLE: "Odblokuj oferty dopasowane do Ciebie",
        DESCRIPTION:
            "Jesteś tylko o krok od otrzymania spersonalizowanych rekomendacji. Uzupełnij dane i powiedz nam, czego dokładnie szukasz. Dzięki temu nasz system odrzuci nietrafione ogłoszenia i pokaże Ci tylko te mieszkania, które naprawdę Cię zainteresują.",
        CTA: "Uzupełnij dane i zobacz oferty"
    }
} as const;

export const HOME_MATCH_TINDER_EMPTY_STATE_CONTENT = {
    TITLE: "Jesteś na bieżąco! Przejrzałeś już wszystkie dopasowane oferty.",
    DESCRIPTION:
        "Na ten moment sprawdziłeś wszystkie inwestycje, które idealnie trafiają w Twoje obecne kryteria. Cały czas trzymamy rękę na pulsie\u00A0- podrzucimy Ci nowe rekomendacje, gdy tylko deweloperzy dodadzą coś nowego.\nNie chcesz czekać? Zobacz, co możesz zrobić już teraz:",
    PREFERENCES: {
        DESCRIPTION: "Wymarzone mieszkanie może być tuż obok. Rozszerz nieco swoje kryteria, by system pokazał Ci nowe oferty.",
        CTA: "zmień preferencje"
    },
    GH: {
        DESCRIPTION: "Wolisz wprowadzić się od zaraz? Sprawdź mieszkania z rynku wtórnego dostępne na GetHome.pl.",
        CTA: "zobacz oferty"
    },
    GH_FINANCE: {
        DESCRIPTION: "Szukaj ze spokojną głową. Sprawdź bezpłatnie swoją zdolność kredytową z ekspertem GetHome Finance.",
        CTA: "umów bezpłatną konsultację"
    }
} as const;

export const HOME_MATCH_TINDER_CONSULTANT_CONTENT = {
    DESCRIPTION:
        "Wybór idealnego mieszkania bywa przytłaczający. Zadzwoń do mnie - wspólnie omówimy Twoje rekomendacje, rozwieję Twoje wątpliwości i pomogę wybrać najlepszą opcję.",
    PHONE: CONSULTANT_PHONE_DISPLAY,
    PHONE_HREF: CONSULTANT_PHONE_HREF,
    ROLE: "Konsultant rynekpierwotny.pl",
    TITLE: "Trudno Ci podjąć decyzję?"
} as const;

export const HOME_MATCH_TINDER_FAVORITES_CTA_CONTENT = {
    LIKE_BUTTON: "Podoba mi się"
} as const;

export type HomeMatchTinderBannerContent = (typeof HOME_MATCH_TINDER_BANNER_CONTENT)[keyof typeof HOME_MATCH_TINDER_BANNER_CONTENT];

export type HomeMatchTinderEmptyStateTileContent =
    | (typeof HOME_MATCH_TINDER_EMPTY_STATE_CONTENT)["PREFERENCES"]
    | (typeof HOME_MATCH_TINDER_EMPTY_STATE_CONTENT)["GH"]
    | (typeof HOME_MATCH_TINDER_EMPTY_STATE_CONTENT)["GH_FINANCE"];
import {CONSULTANT_PHONE_DISPLAY, CONSULTANT_PHONE_HREF} from "@pg-rp/consultants";
import {HOMEMATCH_TINDER_BANNER_RECOMMENDATION_READY_CONTENT} from "@pg-rp/homematch-tinder";

export const HOME_MATCH_TINDER_BANNER_CONTENT = {
    // Shared with RP so the recommendations entry reads the same on both portals.
    RECOMMENDATION_READY: HOMEMATCH_TINDER_BANNER_RECOMMENDATION_READY_CONTENT,
    UNLOCK_REQUIRED: {
        TITLE: "Odblokuj oferty dopasowane do Ciebie",
        DESCRIPTION:
            "Jesteś tylko o krok od otrzymania spersonalizowanych rekomendacji. Uzupełnij dane i powiedz nam, czego dokładnie szukasz. Dzięki temu nasz system odrzuci nietrafione ogłoszenia i pokaże Ci tylko te mieszkania, które naprawdę Cię zainteresują.",
        CTA: "Uzupełnij dane i zobacz oferty"
    }
} as const;

export const HOME_MATCH_TINDER_EMPTY_STATE_CONTENT = {
    TITLE: "Jesteś na bieżąco! Przejrzałeś już wszystkie dopasowane oferty.",
    DESCRIPTION:
        "Na ten moment sprawdziłeś wszystkie inwestycje, które idealnie trafiają w Twoje obecne kryteria. Cały czas trzymamy rękę na pulsie\u00A0- podrzucimy Ci nowe rekomendacje, gdy tylko deweloperzy dodadzą coś nowego.\nNie chcesz czekać? Zobacz, co możesz zrobić już teraz:",
    PREFERENCES: {
        DESCRIPTION: "Wymarzone mieszkanie może być tuż obok. Rozszerz nieco swoje kryteria, by system pokazał Ci nowe oferty.",
        CTA: "zmień preferencje"
    },
    GH: {
        DESCRIPTION: "Wolisz wprowadzić się od zaraz? Sprawdź mieszkania z rynku wtórnego dostępne na GetHome.pl.",
        CTA: "zobacz oferty"
    },
    GH_FINANCE: {
        DESCRIPTION: "Szukaj ze spokojną głową. Sprawdź bezpłatnie swoją zdolność kredytową z ekspertem GetHome Finance.",
        CTA: "umów bezpłatną konsultację"
    }
} as const;

export const HOME_MATCH_TINDER_CONSULTANT_CONTENT = {
    DESCRIPTION:
        "Wybór idealnego mieszkania bywa przytłaczający. Zadzwoń do mnie - wspólnie omówimy Twoje rekomendacje, rozwieję Twoje wątpliwości i pomogę wybrać najlepszą opcję.",
    PHONE: CONSULTANT_PHONE_DISPLAY,
    PHONE_HREF: CONSULTANT_PHONE_HREF,
    ROLE: "Konsultant rynekpierwotny.pl",
    TITLE: "Trudno Ci podjąć decyzję?"
} as const;

export const HOME_MATCH_TINDER_FAVORITES_CTA_CONTENT = {
    LIKE_BUTTON: "Podoba mi się"
} as const;

export type HomeMatchTinderBannerContent = (typeof HOME_MATCH_TINDER_BANNER_CONTENT)[keyof typeof HOME_MATCH_TINDER_BANNER_CONTENT];

export type HomeMatchTinderEmptyStateTileContent =
    | (typeof HOME_MATCH_TINDER_EMPTY_STATE_CONTENT)["PREFERENCES"]
    | (typeof HOME_MATCH_TINDER_EMPTY_STATE_CONTENT)["GH"]
    | (typeof HOME_MATCH_TINDER_EMPTY_STATE_CONTENT)["GH_FINANCE"];
